import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { LinkText } from '@styled';
import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';

// show mobile view for phones & tablets
const breakpoint = mediaQueries.lg;

const Item = styled.li`
    margin: 10px 0 18px 0;
    position: relative;
    font-weight: normal;

    @media ${breakpoint} {
        margin: 10px 18px 18px 0;
    }

    a {
        color: '#7f7f7f';

        @media ${breakpoint} {
            color: ${colors.black};
        }
    }
`;

const SubnavItem = ({ to, label, target }) => {
    return (
        <Item>
            <a href={to} target={target}>
                <LinkText>{label}</LinkText>
            </a>
        </Item>
    );
};

SubnavItem.propTypes = {
    label: PropTypes.string,
    to: PropTypes.string,
    target: PropTypes.string,
};

export default SubnavItem;
